import { Component, OnInit } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { Platform } from '@ionic/angular';
import { addIcons } from 'ionicons';
import { logoApple, logoGooglePlaystore } from 'ionicons/icons';
import { IonButton, IonContent, IonLabel, IonIcon } from "@ionic/angular/standalone";
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-app-update',
  templateUrl: './app-update.page.html',
  styleUrls: ['./app-update.page.scss'],
  standalone: true,
  imports: [IonIcon, IonLabel, IonContent, IonButton, CommonModule]
})
export class AppUpdatePage implements OnInit {

  platform: string
  workinprogress: boolean
  message?: string

  constructor(private plat: Platform) {
    addIcons({logoApple,logoGooglePlaystore});
  }

  ngOnInit() {
    this.platform = Capacitor.getPlatform()
  }

  exitApp() {
    window.location.reload()
  }

}
